import { Icons } from '@/components/Shares/Icons';
import { useLingui } from '@lingui/react';
import { ActionIcon, Flex, Grid, Group, Image, Text, rem } from '@mantine/core';
import Link from 'next/link';
export const FooterBottom: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Grid p={16} mt={12}>
      <Grid.Col span={{
      base: 5,
      sm: 4,
      lg: 3
    }} order={{
      base: 1
    }}>
        <Link href="/">
          <Image src="/apisus.png" alt="Prime logo" w={{
          sm: rem(157),
          md: '100%'
        }} />
        </Link>
      </Grid.Col>
      <Grid.Col span={{
      base: 12,
      lg: 5,
      xl: 6
    }} order={{
      base: 3,
      lg: 2
    }}>
        <Flex h="100%" align="center">
          <Text fz="xs" ta={{
          base: 'justify',
          md: 'left'
        }} c="white">
            {i18n._(`This website offers games with a risk-based experience. You must be
					over 18 years old to use our site. We are not responsible for any
					violations of your local i-gaming laws. Please play responsibly and
					enjoy your time at Apisus.`)}
          </Text>
        </Flex>
      </Grid.Col>
      <Grid.Col span={{
      base: 7,
      sm: 8,
      lg: 4,
      xl: 3
    }} order={{
      base: 2,
      lg: 3
    }}>
        <Flex h="100%" align="center" justify={{
        base: 'end',
        lg: 'space-between'
      }}>
          <Group gap={6} wrap="nowrap">
            <ActionIcon variant="filled" color="var(--mantine-color-dark-10)" w={32} h={32}>
              <Icons className="icon-pr-flat-x" fontSize={20} />
            </ActionIcon>
            <ActionIcon variant="filled" color="var(--mantine-color-dark-10)" w={32} h={32}>
              <Icons className="icon-pr-flat-instagram" fontSize={20} />
            </ActionIcon>
            <ActionIcon variant="filled" color="var(--mantine-color-dark-10)" w={32} h={32}>
              <Icons className="icon-pr-flat-discord" fontSize={20} />
            </ActionIcon>
            <ActionIcon variant="filled" color="var(--mantine-color-dark-10)" w={32} h={32}>
              <Icons className="icon-pr-flat-facebook" fontSize={20} />
            </ActionIcon>
          </Group>
        </Flex>
      </Grid.Col>
    </Grid>;
};